import { Storage } from '@ionic/storage';

const store = new Storage();

export default store;
